export default __webpack_public_path__ + "static/media/tool-icon-cone-low-grey.46ec5095.svg";